import styles from '../styles/Loader.module.scss';

const Loader = () => {
	return <span className={styles.loader}></span>;
};

export default Loader;
